import { SxProps, Theme } from '@mui/material';

export const richTextEditorStyles: Record<string, SxProps<Theme>> = {
  editorWrapper: {
    position: 'relative',
    width: '100%',
    border: 1,
    borderStyle: 'solid',
    borderColor: 'divider',
    borderRadius: '8px',
    bgcolor: 'background.paper',
    transition: 'border-color 0.2s',
    overflow: 'visible', // Allow tooltip to overflow
    '&:hover': {
      borderColor: 'text.disabled',
    },
    '&:focus-within': {
      borderColor: 'primary.main',
      borderWidth: '2px',
    },
    // Resize handle icon (matching TextField)
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '4px',
      right: '4px',
      width: '12px',
      height: '12px',
      backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M1 11L11 1' stroke='%23a1a1aa' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M6 11L11 6' stroke='%23a1a1aa' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E")`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      pointerEvents: 'none',
      zIndex: 1,
    },
  },

  editor: {
    margin: '8px',
    minHeight: '100px',
    padding: '6px 18px 6px 6px', // Match TextField padding (extra right padding for resize handle)
    fontSize: '14px',
    lineHeight: 1.4, // Match TextField lineHeight
    color: 'text.primary',
    outline: 'none',
    wordWrap: 'break-word',
    caretColor: 'text.primary', // Ensure caret is visible

    // Preserve existing inline styles from EHR
    '& *': {},
  },

  tooltip: {
    bgcolor: 'text.primary',
    color: 'background.paper',
    fontSize: '12px',
    padding: '6px 12px',
    borderRadius: '4px',
    maxWidth: '280px',
    pointerEvents: 'none',
    boxShadow: 'custom.cardShadow',
  },

  tooltipTypography: {
    fontSize: '12px',
    color: 'background.paper',
  },
};

export const createRichTextEditorStyles = (
  scaleFontSize: (fontSize: string) => string
): SxProps<Theme> => ({
  ...richTextEditorStyles.editor,
  fontSize: scaleFontSize('14px'),

  // Style macros using CSS attribute selectors (display only, not exported)
  '& [data-question], & [data-field]': {
    fontWeight: 700,
    textDecoration: 'underline',
    textDecorationThickness: '2px',
    textDecorationColor: 'currentColor',
    cursor: 'pointer',
  },
});
